var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{style:(_vm.imageBackground)},[_c('v-row',[_c('v-col',{staticClass:"image-container d-none d-md-flex",attrs:{"cols":"0","md":"7"}},[_c('v-img',{staticClass:"bottom-left",attrs:{"src":"/img/iot.png","max-width":"250"}})],1),_c('v-col',{attrs:{"col2":"12","md":"5"}},[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }